export default {
    form: {
        serverError: 'Ողջույն! Կայքի ադմինիստրացիայում խնդիր կա:',
        globalError: 'Խնդրում ենք կրկին ստուգել պահանջվող դաշտերը և հաստատել:',
        validateMessages: {
            default: '{errorKey}ի համար վավերացման սխալ:',
            required: 'Խնդրում ենք մուտքագրել ձեր {errorKey} դաշտը:',
            email: 'Խնդրում ենք մուտքագրել գոյություն ունեցող էլ. հասցե',
            password: 'Գաղտնաբառը պետք է ունենա առնվազն 8 նիշ:',
            enum: '{errorKey}ը պետք է լինի [{enum}] արժեքներից մեկը:',
            whitespace: '{errorKey}ը չի կարող դատարկ լինել:',
            phone: 'Խնդրում ենք մուտքագրել գոյություն ունեցող {errorKey}:',
            date: {
                format: '{errorKey}ի ֆորմատը գոյություն չունի:',
                parse: '{errorKey}ը չի կարող անցնել որպես ամսաթիվ:',
                invalid: '{errorKey}ը ամսաթիվը գոյություն չունի:',
            },
            string: {
                len: '{errorKey}ը պետք է լինի ճիշտ {len} նիշ:',
                min: '{errorKey}ը պետք է լինի առնվազն {min} նիշ:',
                max: '{errorKey}ը չի կարող լինել {max} նիշից երկար:',
                range: '{errorKey}ը պետք է լինի {min} և {max} նիշերի միջև:',
            },
            number: {
                len: '{errorKey}ը պետք է հավասար լինի {len}-ին:',
                min: '{errorKey}ը չի կարող լինել {min}-ից պակաս:',
                max: '{errorKey}ը չի կարող լինել {max}-ից ավելին:',
                range: '{errorKey}ը պետք է լինի {min} և {max} միջև:',
            },
            array: {
                len: '{errorKey}ը պետք է լինի ճիշտ {len} երկարություն:',
                min: '{errorKey}ը չի կարող լինել {min}-ից պակաս երկարությամբ:',
                max: '{errorKey}ը չի կարող լինել {max}-ից ավել երկարությամբ:',
                range: '{errorKey}ը պետք է լինի {min} և {max} երկարության միջև:',
            },
            pattern: {
                mismatch: '{errorKey}ը չի համապատասխանում {pattern}-ին',
            },
        },
    },
};
//# sourceMappingURL=hy.js.map